<mat-accordion>
    <mat-expansion-panel (opened)="panelOpenState1 = true"
                (closed)="panelOpenState1 = false" [ngStyle]="{'background-color': panelOpenState1 ? '#F2FBFE' : 'transparent', 'border-radius': panelOpenState1 ? '12px' : '0px'}">
        <mat-expansion-panel-header>
        <mat-panel-title [ngStyle]="{'font-size': appServiceScreenDesktop ? '20px' : appServiceScreenMobileSmall ? '14px' : '16px'}" style="font-weight: 400;color: #222222;">
            {{'faqQ13' | translate}}
        </mat-panel-title>
        </mat-expansion-panel-header>
        <p [ngStyle]="{'font-size': appServiceScreenDesktop ? '16px' : appServiceScreenMobileSmall ? '12px' : '14px'}" style="font-weight: 400;color: #717171;padding: 10px;text-align: start;">{{'faqA13' | translate}}</p>
    </mat-expansion-panel>
    <mat-expansion-panel (opened)="panelOpenState2 = true" style="margin: 15px 0px 15px 0px;"
                (closed)="panelOpenState2 = false" [ngStyle]="{'background-color': panelOpenState2 ? '#F2FBFE' : 'transparent', 'border-radius': panelOpenState2 ? '12px' : '0px'}">
        <mat-expansion-panel-header>
        <mat-panel-title  [ngStyle]="{'font-size': appServiceScreenDesktop ? '20px' : appServiceScreenMobileSmall ? '14px' : '16px'}" style="font-weight: 400;color: #222222;">
            {{'faqQ23' | translate}}
        </mat-panel-title>
        </mat-expansion-panel-header>
        <p [ngStyle]="{'font-size': appServiceScreenDesktop ? '16px' : appServiceScreenMobileSmall ? '12px' : '14px'}" style="font-weight: 400;color: #717171;padding: 10px;text-align: start;">{{'faqA23' | translate}}</p>
    </mat-expansion-panel>
</mat-accordion>